import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/layout/header/header.component';
import { SidebarComponent } from './components/layout/sidebar/sidebar.component';
import { RightsidebarComponent } from './rightsidebar/rightsidebar.component';
import { CaseDetailsService } from './components/home/case-details/case-details.service';
import { NotificationsComponent } from './shared/dynamic-components/notifications/notifications.component';
import { SharedService } from './shared/services/shared.service';
import { NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, CommonModule, SidebarComponent, RightsidebarComponent,NotificationsComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  // animations: [
  //   trigger('slidein', [
  //     transition(':enter', [
  //       style({ transform: 'translateX(-100%)', opacity: 0 }),
  //       animate(
  //         '250ms ease-out',
  //         style({ transform: 'translateX(0)', opacity: 0 })
  //       ),
  //     ]),
  //     transition(':leave', [
  //       animate(
  //         '250ms ease-in',
  //         style({ transform: 'translateX(-100%)', opacity: 0 })
  //       ),
  //     ]),
  //   ]),
  // ],
})
export class AppComponent {
  title = 'fraud-management';
  @Output() closeSideBar = new EventEmitter<boolean>();
  expanded: boolean = true;
  sidebarVisible: boolean = false;
  selectedTab: string = 'all';
  isLoading: boolean = false;
  isLoginPage: boolean = false;

  constructor(
    private sharedService: SharedService,
    private router: Router
  ) {
    this.checkScreenSize();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.isLoginPage = event.urlAfterRedirects.includes('/login');
    });
  }
  @HostListener('window:resize', ['$event'])
  checkScreenSize() {
    if (window.innerWidth < 1024) {
      this.expanded = false;
    } else {
      this.expanded = true;
    }
    this.closeSideBar.emit(this.expanded);
  }
  expandBtn() {
    this.expanded = !this.expanded;
    this.closeSideBar.emit(this.expanded);
  }
  ngOnInit() {
    localStorage.setItem('showEditDelete', 'false');
    this.sharedService.isLoading.subscribe((loading) => {
      this.isLoading = loading;
    });

    this.checkAuthentication();
  }

  private checkAuthentication() {
    const user = this.sharedService.getCurrentUser();
    const currentUrl = this.router.url;

    if (!user && !currentUrl.includes('/login')) {
      this.router.navigate(['/login']);
    }
  }
 

}